// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2otSh","container":"Header_container__3UMvB","logo":"Header_logo__2yYRj","navigation":"Header_navigation__36OsL"};